<template>
  <div id="port-menu" v-if="hasAddonGkmgPortMaster">
    <span>
      <span class="admin-icon-text">{{ displayingAuthName }}</span>
      <img
        class="admin-icon"
        :src="back_ground"
        icon="FileTextIcon"
        svgClasses="h-6 w-6"
      />
      <img
        class="inside-admin-icon"
        :src="account"
        icon="FileTextIcon"
        svgClasses="h-6 w-6"
      />
    </span>
    <div class="menu-section">
      <destination-order-list />
    </div>
    <div class="card vx-card p-6 enterprise-port-menu">
      <template>
        <div class="menu-section">
          <div class="header">
            <div class="icon-area">
              <feather-icon icon="AnchorIcon" svgClasses="h-7 w-7" />
            </div>
            <div class="title">港湾管理メニュー</div>
          </div>
          <div>
            <div class="menu-button-area">
              <vs-button
                class="port-menu-button"
                type="border"
                color="#2D9CDB"
                v-for="(item, index) in enterprisePortMenuItemsSorted"
                :key="index"
                :to="{ name: item.path }"
              >
                {{ item.name }}
              </vs-button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import FileSaver from "file-saver";
import DestinationOrderList from "../destination-order-list/DestinationOrderList";

const { mapActions, mapGetters, mapState } =
  createNamespacedHelpers("gkmgPortMaster");

export default {
  components: {
    DestinationOrderList,
  },
  data() {
    return {
      iconOffice: require("@/assets/images/icons/lolcal/corporate_fare.svg"),
      selectedControl: null,
      reportPopupActive: false,
      inputDate: new Date(),
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        locale: Japanese,
        static: true,
        inline: true,
      },
      enterprisePortMenuItemsSorted: null,
      back_ground: require("@/assets/images/icons/gkmg-port-master/back_ground.svg"),
      account: require("@/assets/images/icons/gkmg-port-master/account.svg"),
    };
  },
  computed: {
    ...mapState({
      enterprisePortMenuItems: (state) => state.enterprisePortMenuItems,
    }),
    ...mapGetters(["gkmgPortMasterAuth", "hasAddonGkmgPortMaster"]),
    displayingAuthName() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.displayNameを持つ
      return this.gkmgPortMasterAuth.PortMenu.displayName;
    },
  },
  async mounted() {
    if (!this.hasAddonGkmgPortMaster) return;
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
    this.enterprisePortMenuItemsSorted = this.enterprisePortMenuItems.reduce(
      (prev, curr) => {
        if (["船舶管理"].includes(curr.name)) {
          prev.push(curr);
        }
        return prev;
      },
      [],
    );
    await this.getGkmgPortMasterAuth();
  },
  methods: {
    ...mapActions(["exportDailyReports", "getGkmgPortMasterAuth"]),
    clickReportDownload() {
      this.reportPopupActive = true;
    },
    async callDownloadReport() {
      let payload = {
        date: moment(this.inputDate).format("YYYYMMDD"),
      };
      this.$vs.loading();
      try {
        let res = await this.exportDailyReports(payload);
        const date = moment(this.inputDate).format("YYYYMMDD");
        const fileName = `日報_${date}.xlsx`;
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#port-menu {
  .nav-item-top {
    width: 100px;
    padding: 10px;
    color: white;
    background: #2d9cdb;
    border-radius: 6px 0px 0px 6px;
  }
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    .icon-area {
      width: 45px;
    }
  }
  .menu-button-area {
    margin: 5px 0px;
  }
  .port-menu-button,
  .enterprise-menu-button {
    margin: 5px 10px 5px 0px;
    span {
      font-weight: normal;
    }
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 45px;
  }
  .title {
    font-weight: bold;
    margin-bottom: 15px;
  }
  .report-download-button {
    margin-left: auto;
    &-inner {
      display: flex;
      align-items: center;
    }
  }
  .office-icon {
    fill: #626262;
  }
  .port-select-box {
    margin: 10px 0px;
  }
  .link-list {
    border: 1px solid;
    border-radius: 5px;
    border-color: #e3e4e5;
    overflow: hidden;
    margin: 20px 0px;
  }
  .list-item {
    padding: 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid;
    border-color: #e3e4e5;
    cursor: pointer;
    a,
    a:visited {
      display: flex;
      color: #636363;
      width: 100%;
    }
    &:hover {
      background: #79c0e8;
      transition: 0.2s;
      a {
        color: $pm-white;
      }
    }
    .external-link-icon {
      margin-left: auto;
    }
  }
  .list-item.active {
    background: #2d9cdb;
    color: #f2f2f2;
    overflow: hidden;
  }
  .last-item {
    border-bottom: 0px solid;
  }
  .display-icon {
    margin: 0px 20px;
  }
  .item-title {
    font-weight: bold;
    width: 150px;
  }
  .port-select-box {
    width: 200px;
  }
  .display-button {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  .control-area {
    display: flex;
    justify-content: center;
  }
}
.report-download-popup {
  .vs-popup {
    width: 400px !important;
  }
  .vs-popup--content {
    text-align: center;
  }
  .button-area {
    margin-top: 15px;
  }
  .flatpickr-input {
    display: none;
  }
  .flatpickr-day.selected,
  .flatpickr-day.nextMonthDay.selected,
  .flatpickr-day.prevMonthDay.selected {
    background: $pm-blue !important;
    border-color: $pm-blue !important;
    &:hover,
    &:focus {
      background: $pm-blue !important;
      border-color: $pm-blue !important;
    }
  }
}
.admin-icon-text {
  position: absolute;
  top: 30px;
  right: 90px;
  width: 48.5px;
  height: 24px;
  font-size: 16px;
  text-align: left;
}
.admin-icon {
  position: absolute;
  top: 25px;
  right: 40px;
}
.inside-admin-icon {
  position: absolute;
  top: 30px;
  right: 43px;
}
</style>
